import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import "sweetalert2/dist/sweetalert2.min.css";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";
import HeaderModule from "../../components/Header/HeaderModule";
import { dateFormat } from "../../common/common";
import { Box } from "@mui/material";
import { Modal } from "react-bootstrap";
import { Eye } from "feather-icons-react/build/IconComponents";

const CanceledAppointment = () => {
  const user_data = useSelector((state) => state.user_data);
  const [productlist, setProductlist] = useState([]);
  const [appintmentServiceData, setAppintmentServiceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [filterAppointmentID, setFilterAppointmentID] = useState(0);

  const formatDBPhoneNumber = (number) => {
    if (!number) return "";

    let cleaned = number.replace(/\D/g, ""); // remove non-digits
    if (cleaned.startsWith("61")) {
      cleaned = "+" + cleaned;
    } else if (cleaned.startsWith("0")) {
      cleaned = "+61" + cleaned.substring(1);
    } else if (!cleaned.startsWith("+61")) {
      cleaned = "+61" + cleaned;
    }

    const noPlus = cleaned.replace("+", "");

    return "+" + noPlus.replace(/^61(\d)(\d{4})(\d{4})$/, "61 $1 $2 $3");
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      sortingFn: "numeric",
      size: 100,
    },
    {
      header: "Business Name",
      accessorKey: "businessUniqueName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Scheduled Date",
      accessorKey: "Date",
      Cell: ({ row }) => {
        return (
          <div>{row.original.Date ? dateFormat(row.original.Date) : "-"}</div>
        );
      },
    },
    {
      header: "Created Date",
      accessorKey: "createdAt",
      Cell: ({ row }) => {
        return (
          <div>
            {row.original.createdAt ? dateFormat(row.original.createdAt) : "-"}
          </div>
        );
      },
    },
    // {
    //   header: "startTime",
    //   accessorKey: "startTime",
    // },
    // {
    //   header: "endTime",
    //   accessorKey: "endTime",
    // },
    {
      header: "IsGroup",
      accessorKey: "IsGroup",
      Cell: ({ row }) => {
        return <div>{row.original.IsGroup == 1 ? "YES" : "NO"}</div>;
      },
    },
    {
      header: "cust. Name",
      accessorKey: "customerName",
    },
    {
      header: "cust. Email",
      accessorKey: "customerEmail",
    },
    {
      header: "cust. Number",
      accessorKey: "customerNumber",
      Cell: ({ cell }) => formatDBPhoneNumber(cell.getValue()),
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          <button
            className="btn btn-outline-primary btn-sm me-2"
            onClick={() => {
              setFilterAppointmentID(row.original.ID);
              setShowModal(true);
            }}
          >
            <Eye className="custome-icon-size" />
          </button>
        </Box>
      ),
    },

    // {
    //   header: "Service Data",
    //   accessorKey: "ServiceData",
    //   Cell: ({row}) => {
    //     return <div>
    //         {
    //             appintmentServiceData?.filter(el => el.appointmentId === row.original.ID)?.map((item, index) =>{
    //                 <p key={index}>Service: {item?.serviceName} </p>
    //             })
    //         }
    //     </div>
    //   }
    // }
  ];

  const prodcutDataListApi = async () => {
    setLoading(true);
    const response = await apiHandler({
      method: "GET",
      route: `Business/businesscanceledappointmentbyid?businessId=${
        user_data?.businessId || 0
      }`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData?.CancelAppointments);
      setAppintmentServiceData(
        response.ResponseData?.CancelAppointmentsServices
      );
      setLoading(false);
    } else {
      console.log(response, "data");
      setLoading(false);
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, []);

  const exportData = productlist.map((item) => ({
    ID: item?.ID,
    BusinessName: item?.businessName,
    Question: item?.question,
    Answer: item?.answer,
  }));

  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <HeaderModule
            refreshData={prodcutDataListApi}
            exportData={exportData}
          />

          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-responsive">
                <CommonMaterialReactTable
                  columns={columns}
                  data={productlist}
                  columnRightPin={["actions"]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
<Modal
  show={showModal}
  onHide={() => setShowModal(false)}
  centered
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title className="fw-bold text-primary">
      Canceled Service
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {appintmentServiceData?.filter(
      (el) => el.appointmentId === filterAppointmentID
    )?.length ? (
      (() => {
        const services = appintmentServiceData.filter(
          (el) => el.appointmentId === filterAppointmentID
        );

        const common = services[0]; // pick shared info from first item

        return (
          <div
            style={{
              padding: "15px",
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
            }}
          >
            {/* Common details */}
            <div style={{ marginBottom: "15px", fontSize: "0.9rem" }}>
              <div style={{ fontWeight: "600", color: "#5a2c83" }}>
                <span className="text-black">Person: </span>{" "}
                {common.customerName || "Customer"}
              </div>
              <div style={{ fontWeight: "600", color: "#5a2c83" }}>
                <span className="text-black">Number: </span>{" "}
                {formatDBPhoneNumber(common.customerNumber)}
              </div>
              <div style={{ fontWeight: "600", color: "#6b1e99" }}>
                <span className="text-black">Time: </span>
                {`${new Date(common.Date).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })} - ${new Date(`1970-01-01T${common.startTime}`)
                  .toLocaleTimeString("en-US", {
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  })
                  .replace(" AM", "")
                  .replace(" PM", "")}`}
              </div>
              <div
                style={{
                  color:
                    common.paymentStatus?.toLowerCase() === "paid"
                      ? "#00b86b"
                      : "#c07600",
                }}
              >
                <span className="text-black">Payment Status: </span>
                <strong>
                  {common.paymentStatus?.toLowerCase() === "paid"
                    ?  `Paid ($${common?.Total})`
                    : `Pay At Venue ($${common?.Total})`}
                </strong>
              </div>
              <div>
                        {/* 👤 */}
                        <spna className="text-black">Cancel Reason: </spna>{" "}
                        {common.cancelReason || ""}
                      </div>
            </div>

            {/* Services table */}
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "0.85rem",
              }}
            >
              <thead>
                <tr className="text-black fw-bold"
                // style={{ background: "var(--primary)" }}
                >
                  <th
                    style={{ border: "1px solid #ddd", padding: "6px" }}
                    align="left"
                  >
                    Service
                  </th>
                  <th
                    style={{ border: "1px solid #ddd", padding: "6px" }}
                    align="left"
                  >
                    Duration
                  </th>
                  <th
                    style={{ border: "1px solid #ddd", padding: "6px" }}
                    align="left"
                  >
                    Member
                  </th>
                  {/* <th
                    style={{ border: "1px solid #ddd", padding: "6px" }}
                    align="left"
                  >
                    Price
                  </th> */}
                  {/* <th
                    style={{ border: "1px solid #ddd", padding: "6px" }}
                    align="left"
                  >
                    Cancel Reason
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {services.map((s) => (
                  <tr key={s.appointmentdetileId}>
                    <td className="text-black" style={{ border: "1px solid #ddd", padding: "6px" }}>
                      {s.serviceName}
                    </td>
                    <td className="text-black" style={{ border: "1px solid #ddd", padding: "6px" }}>
                      {s.serviceduration}
                    </td>
                    <td className="text-black" style={{ border: "1px solid #ddd", padding: "6px" }}>
                      {s.teamName || "Any Professional"}
                    </td>
                    {/* <td className="text-black" style={{ border: "1px solid #ddd", padding: "6px" }}>
                      ${s.Total || s.serviceprice}
                    </td> */}
                    {/* <td style={{ border: "1px solid #ddd", padding: "6px" }}>
                      {s.cancelReason || "-"}
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })()
    ) : (
      <div className="text-center text-muted">
        No services found for this appointment.
      </div>
    )}
  </Modal.Body>
</Modal>

    </>
  );
};

export default CanceledAppointment;
